import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import 'antd/dist/reset.css';
import './assets/styles/SCSS/index.scss';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
